(() => {
  if (window.__lgCollectionMenuScroll) return;
  window.__lgCollectionMenuScroll = true;

  const selector = '[data-lg-collection-scroll]';
  let frameId;
  const observed = new WeakSet();
  const number = (value) => parseFloat(value) || 0;

  const setProperty = (element, property, value) => {
    if (element.style.getPropertyValue(property) !== value) {
      element.style.setProperty(property, value);
    }
  };

  const fit = (grid) => {
    const items = Array.from(grid.children);
    const menu = grid.closest('.lg-mega-menu');
    if (!menu || !items.length) return;

    if (window.innerWidth < 1000) {
      grid.style.removeProperty('--lg-collection-rows');
      items.forEach((item) => {
        item.style.removeProperty('grid-row');
        item.style.removeProperty('grid-column');
      });
      return;
    }

    const menuRect = menu.getBoundingClientRect();
    const gridRect = grid.getBoundingClientRect();
    if (!menuRect.height || !gridRect.width) return;

    const style = getComputedStyle(grid);
    const columns = Math.max(1, number(style.getPropertyValue('--lg-collection-columns')));
    const rowHeight = items[0].getBoundingClientRect().height;
    if (!rowHeight) return;
    const rowGap = number(style.rowGap);
    const viewportBottom = window.visualViewport
      ? window.visualViewport.offsetTop + window.visualViewport.height
      : window.innerHeight;
    let bottom = Math.min(menuRect.bottom, viewportBottom);

    if (grid.dataset.lgCollectionScroll === 'focus') {
      const linklist = grid.closest('.mega-menu__linklist');
      const linkStyle = getComputedStyle(linklist);
      bottom -= number(linkStyle.paddingBottom);
      const products = linklist.querySelector('.lg-mega-menu__focus-products');
      if (products) {
        const productStyle = getComputedStyle(products);
        const heading = products.querySelector('.lg-mega-menu-focus-products__header');
        const headingStyle = heading ? getComputedStyle(heading) : null;
        const rootSize = number(getComputedStyle(document.documentElement).fontSize) || 16;
        const productWidth = Math.min(10.5 * rootSize, Math.max(9 * rootSize, window.innerWidth * 0.1));
        const headingSpace = heading
          ? heading.getBoundingClientRect().height + number(headingStyle.marginBottom)
          : 0;
        bottom -= productWidth * 1.25 + headingSpace
          + number(productStyle.paddingTop) + number(productStyle.borderTopWidth)
          + number(linkStyle.rowGap);
      }
    } else if (grid.dataset.lgCollectionScroll !== 'selection') {
      // Les autres grilles gardent leur réserve dédiée. La Sélection utilise
      // toute la hauteur disponible afin de ne pas masquer une ligne de cartes
      // lorsqu'une fenêtre desktop est réduite ou non maximisée.
      bottom -= Math.max(24, Math.min(42, rowHeight * 0.5));
    }

    const gridExtraHeight = number(style.paddingTop) + number(style.paddingBottom)
      + Math.max(0, number(grid.offsetHeight) - number(grid.clientHeight));
    const availableHeight = Math.max(rowHeight, bottom - gridRect.top - gridExtraHeight);
    const fittingRows = Math.max(1, Math.floor((availableHeight + rowGap + 1) / (rowHeight + rowGap)));
    const rows = Math.min(fittingRows, Math.ceil(items.length / columns));
    const pageSize = rows * columns;
    setProperty(grid, '--lg-collection-rows', String(rows));

    items.forEach((item, index) => {
      const page = Math.floor(index / pageSize);
      const position = index % pageSize;
      setProperty(item, 'grid-row', String(Math.floor(position / columns) + 1));
      setProperty(item, 'grid-column', String(page * columns + position % columns + 1));
    });
  };

  const schedule = () => {
    if (frameId) cancelAnimationFrame(frameId);
    frameId = requestAnimationFrame(() => {
      frameId = undefined;
      document.querySelectorAll(selector).forEach(fit);
    });
  };

  const resizeObserver = new ResizeObserver(schedule);
  const register = () => {
    document.querySelectorAll(selector).forEach((grid) => {
      if (observed.has(grid)) return;
      observed.add(grid);
      resizeObserver.observe(grid);
      resizeObserver.observe(grid.closest('.lg-mega-menu'));
    });
    schedule();
  };

  register();
  document.fonts?.ready.then(schedule);
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('orientationchange', schedule, { passive: true });
  window.visualViewport?.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('shopify:section:load', register);
  document.addEventListener('shopify:block:select', schedule);
  new MutationObserver((mutations) => {
    if (mutations.some((mutation) => mutation.attributeName === 'open')) {
      schedule();
      setTimeout(schedule, 80);
    }
  }).observe(document.documentElement, {
    subtree: true,
    attributes: true,
    attributeFilter: ['open']
  });
})();

